import React, { useState } from "react";
import logo from "../img/logo.png";
import "./Header.css";
import { Menu } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import logowhite from "../img/logowhite.png";
function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="Header">
      <div className="Header__logoleft">
        <a href="/">
          <img src={logo} alt="Luxury villa with sea view in Costa Blanca, Spain" />
        </a>
      </div>
      <div className="Header__exclusivity">
        <p>US Exclusivity for Cabrera Fine Properties</p>
      </div>
      <div className="Header__right__menu">
        <div className="Header__dropdown">
          <p className="Header__dropdownButton">Properties</p>
          <div className="Header__dropdownMenu">
            <a href="/properties">All</a>
            <a href="/ModernProperties">Contemporary</a>
            <a href="/RusticProperties">Rustic</a>
            <a href="/ResaleProperties">Resale</a>
          </div>
        </div>
        <a href="/yourrealtor">
          <p>Your Realtor</p>
        </a>
        <a href="/investors">
          <p>Investors</p>
        </a>
        <a href="/about">
          <p>About</p>
        </a>
        <a href="/contact">
          <p>Contact</p>
        </a>
      </div>
      <div className="Header__mobile__menu" onClick={toggleMenu}>
        <Menu style={{ fontSize: "30px" }} />
      </div>

      {isMenuOpen && (
        <div className="SideMenu">
          <div className="SideMenu__header">
            <CloseIcon
              style={{ fontSize: "30px" }}
              onClick={toggleMenu}
              className="SideMenu__closeIcon"
            />
          </div>
          <div className="SideMenu__links">
            <a href="/">Home</a>
            <a href="/properties">Properties</a>
            <div className="Submenu__mobile">
              <a href="/properties">All</a>
              <a href="/ModernProperties">Contemporary</a>
              <a href="/RusticProperties">Rustic</a>
              <a href="/ResaleProperties">Resale</a>
            </div>
            <a href="/yourrealtor">Your Realtor</a>
            <a href="/investors">Investors</a>
            <a href="/about">About Costa Blanca</a>
            <a href="/contact">Contact</a>
          </div>
          <div className="SideMenu__logofixedtobottom">
            <img src={logowhite} alt="Luxury villa with sea view in Costa Blanca, Spain" />
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
